import { createClient } from '@supabase/supabase-js'

export const supabaseGestionPension = createClient(
  process.env.REACT_APP_SUPABASE_URL_GESTION_PENSION,
  process.env.REACT_APP_SUPABASE_ANON_KEY_GESTION_PENSION,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'gp-auth'
    }
  }
)
